var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.isShow),expression:"isShow"}],staticClass:"toast"},[(_vm.type)?_c('i',{class:['icon', _vm.type ? _vm.type : '']}):_vm._e(),_c('i',{staticClass:"txt"},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }